import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';
import {
	type SampleProjectSessionKey,
	SAMPLE_PROJECT_SESSION_STORE_KEY,
} from '../../constants.tsx';

const useSampleProjectSessionStorage = (
	sessionVariableKey: SampleProjectSessionKey,
	projectId?: Number | null,
) => {
	const store = createSessionStorageProvider(SAMPLE_PROJECT_SESSION_STORE_KEY);
	const viewSampleProjectUserProperty = store.get(sessionVariableKey);

	const removeSessionVariable = () => {
		store.remove(sessionVariableKey);
	};

	if (!viewSampleProjectUserProperty) {
		return {
			removeSessionVariable,
			shouldShowSampleProjectCta: false,
			shouldShowSampleProjectItem: false,
			projectIds: [],
		};
	}

	const parsedSampleProjectUserProperty = JSON.parse(viewSampleProjectUserProperty);

	const status = parsedSampleProjectUserProperty.status;
	const projectIds = parsedSampleProjectUserProperty.projectIds;
	const shouldShowSampleProjectCta = !!(status === 'ENABLED');
	const shouldShowSampleProjectItem = !!(status === 'ENABLED' && projectIds.includes(projectId));

	return {
		removeSessionVariable,
		projectIds,
		shouldShowSampleProjectCta,
		shouldShowSampleProjectItem,
	};
};

export default useSampleProjectSessionStorage;
